import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function TableIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <Box
        as="path"
        fillRule="evenodd"
        fill="currentColor"
        d="M2 8c0-1.718 1.267-3 3-3h14c1.733 0 3 1.393 3 3.111V16c0 1.718-1.267 3-3 3H5c-1.733 0-3-1.282-3-3V8Zm3-1c-.433 0-1 .57-1 1v1h16V8c0-.43-.567-1-1-1H5Zm15 4h-7v2h7v-2Zm0 4h-7v2h6c.433.333 1-.57 1-1v-1Zm-9 2v-2H4v1c0 .43.567 1 1 1h6Zm-7-4h7v-2H4v2Z"
        clipRule="evenodd"
      />
    </Icon>
  );
}
